import React, {useState, useEffect, useContext} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
// import { Link } from 'react-router-dom';
import { history } from '../../_helpers';
import Select from 'react-select';
import './ComSingleSearch.scss'

// import { fieldOptions, SMjobOptions, freshOptions, schoolOptions, majorOptions, abilityOptions, interestOptions, tagOptions, degreeOptions, companyOptions, lookOptions, yearOptions } from '../SignIn/data';

function ComSingleSearch(){
  const [state, actions] = useContext(UserContext);

  const [userlist, setUserlist] = useState()
  const [school, setSchool] = useState()
  const [work, setWork] = useState()
  const [resume, setResume] = useState()
  const [paper, setPaper] = useState()

  const [ra, setRa] = useState()
  const [actionbtn, setActionbtn] = useState()

  let user = JSON.parse(String(localStorage.getItem('user')))
  let email = String(localStorage.getItem('email'))
  const header = {Authorization: `JWT ${user.token}`}
  

  let candidate = history.location.pathname.split('/')[3]
  let whichDB = history.location.pathname.split('/')[4]
  // let whichResume = history.location.pathname.split('/')[5]

  let hhlink = '';
  let userlink = '';
  let schoollink = '';
  let worklink = '';
  let resumelink = '';
  let paperlink = '';
  let apilink = '';

  if(localStorage.getItem("is_headhunter") === "true") hhlink = "/api/rahh/"
  else if(localStorage.getItem("is_recruiter") === "true") hhlink = "/api/ra/"

  if(whichDB==="DB2") {
    userlink = "/user/usersecond/?email=" + candidate
    schoollink = "/user/schoolsecond/?email=" + candidate
    worklink = "/user/worksecond/?email=" + candidate
    resumelink = "/user/resumesecond/?email=" + candidate
    paperlink = "/user/papersecond/?email=" + candidate
  }
  else{
    userlink = "/user/userlist/?email=" + candidate
    schoollink = "/user/school/?email=" + candidate
    worklink = "/user/work/?email=" + candidate
    resumelink = "/api/resume/?email=" + candidate
    paperlink = "/api/paper/?email=" + candidate
  }

  // function fetchReCart(id, status, step, candidate, which){
  //   if(window.confirm(candidate + step + "?")){
  //     fetch(state.awslink + "/api/recartshop/", {
  //       method: 'POST',
  //       headers: header,
  //       body:JSON.stringify({
  //         "id": id,
  //         "status": status,
  //         "step": step,
  //         "candidate": candidate,
  //         "which": which,
  //       })
  //     })
  //     .then(response => response.json())
  //     .then(json=>{
  //       fetchUserResume()
  //     })
  //   }
  // }

  useEffect(()=>{


    async function fetchRalist(){
      fetch(state.awslink + hhlink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        // let arr = []
        let newobj = [];

        if(hhlink === "/api/rahh/"){
          if(json["ra"])
            if(json["ra"].length)
              {json["ra"].map((item, index)=>{
                newobj.push({"value": item.title, "label": item.title, "id": item.id, "status": item.status})
                return null
              })}
          if(json["ra_shop_hh"])
            if(json["ra_shop_hh"].length)
              {json["ra_shop_hh"].map((item, index)=>{
                newobj.push({"value": item.title, "label": item.title, "id": item.id, "status": item.status})
                return null
              })}
          if(json["ra_shop_7"])
            if(json["ra_shop_7"].length)
              {json["ra_shop_7"].map((item, index)=>{
                newobj.push({"value": item.title, "label": item.title, "id": item.id, "status": item.status})
                return null
              })}
            // console.log(arr)
          setRa(newobj)
        }
        else{
          let newobj = []
          if(json)
            if(json.length)
              json.map((item, index)=>{
                newobj.push({"value": item.title, "label": item.title, "id": item.id, "status": item.status})
                return null
              })
          
          setRa(newobj)
        }
        
      }
      )
    }

    async function fetchUserlist(){
      fetch(state.awslink + userlink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setUserlist(json)
      }
      )
    }

    async function fetchUserSchool(){
      fetch(state.awslink + schoollink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setSchool(json)
      }
      )
    }
    
    async function fetchUserWork(){
      fetch(state.awslink + worklink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setWork(json)
      }
      )
    }

    async function fetchUserResume(){
      fetch(state.awslink + resumelink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setResume(json[0])
      }
      )
    }

    async function fetchUserPaper(){
      fetch(state.awslink + paperlink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setPaper(json)
      }
      )
    }
    fetchRalist();
    fetchUserlist()
    fetchUserSchool()
    fetchUserWork()
    fetchUserResume()
    fetchUserPaper()
    
  },[])

  // console.log(applicant[0].email)
  // if(ralist === null){
  //   if(state.token != undefined)
  //     fetchRalist();
  // }
  function fetchCart(e, step){
    console.log(e)
    // console.log(e.id)
    if(step === "추천"){
      if(whichDB === "DB1") {step = "추천제안"}
      // else일때 내꺼인지 아닌지 구분
      else {
        if(email === userlist.user["email"]){
          step = "추천"
        }
        else {step = "추천제안"}
      }
    }

    console.log(whichDB, step)
    fetch(state.awslink + "/api/recartshop/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "candidate": candidate,
        "step": step,
        "status": e.status,
        "which": whichDB,
        "id": e.id
      })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setResume(json)
      })

      let add_link
      if(e.status === "7%") add_link = "ra"
      else add_link = "rahh"
    
      // history.push('/recruiter/raboard/' + e.id + '/' +add_link )
    
  }

  // console.log(ra, SMjobOptions)
  // console.log(email, userlist.user["email"])
  
  return(
    <>
    {state.width < state.breakpoint ? null
      :
      <Wrapper>
        <RaWrapper>

          
          {userlist&& school&&work&&resume&&paper ?
            <>
            <ProfileForm>
              <HeaderForm >
                <ImgWrapper>
                  <img 
                    src = {userlist.profilelink ? userlist.profilelink : "dummy"} 
                    onError={(e)=> {
                        e.target.src = state.noimage
                    }}
                    alt = 'profile'
                  />
                  <div className={"name"}>{userlist.realname}</div>

                </ImgWrapper>

                <div>
                  {actionbtn? 
                  <div>
                    {actionbtn}
                  </div>
                  :
                  <div>
                    {ra && 
                    <>
                      <Select
                        className="choice-single"
                        defaultValue={{label: "장바구니"}}
                        // isSearchable={true}
                        
                        options={ra}
                        onChange={(e)=>{fetchCart(e, "장바구니")}}
                      />
                      {localStorage.getItem("is_headhunter") === "true" &&
                        <Select
                          className="choice-single"
                          defaultValue={{label: "추천하기"}}
                          // isSearchable={true}
                          options={ra}
                          onChange={(e)=>{fetchCart(e, "추천")}}
                        />
                      }
                      
                      <Select
                        className="choice-single"
                        defaultValue={{label: "면접제안"}}
                        // isSearchable={true}
                        
                        options={ra}
                        onChange={(e)=>{console.log(e)}}
                      />
                      </>
                    }
                  </div>
                  }
                  
                </div>

              </HeaderForm>
            
              <ContentForm>
                <div>
                  <h4>
                    직무
                  </h4>
                  <div>
                    {userlist.field} - {userlist.job}
                  </div>
                </div>

                <div>
                  <h4>
                    요소기술
                  </h4>
                  <div className={"ras-tag"}>
                    {resume.abilities &&
                    resume.abilities.map((item)=>{
                      return(<div>{item}</div>)
                    })}
                  </div>
                </div>

                <div>
                  <h4>
                    태그
                  </h4>
                  <div className={"ras-tag"}>
                    {resume.tag &&
                    // userlist.tag.length &&
                     resume.tag.map((item)=>{
                      return(<div>{item}</div>)
                    })}
                  </div>
                </div>

                <div>
                  <h4>
                    도메인
                  </h4>
                  <div className={"ras-tag"}>
                    {userlist.domain && userlist.domain.map((item)=>{
                      return(<div>{item}</div>)
                    })}
                  </div>
                </div>

                <div>
                  <h4>
                    특장점
                  </h4>
                  <div>
                    {resume.strength}
                  </div>
                </div>
                  
                

                <div>
                  <h4>
                    경력
                  </h4>
                  <div className={"ras-work"}>
                    {work.map((item)=>{
                      return(
                        <div>
                          <h4>
                            {item.title}
                          </h4>
                          <div className={"qu-add"}>
                            {item.depart}
                          </div>
                          <div className={"qu-add"}>
                            {item.start} - {item.end}
                          </div>

                          {/* EditorState? */}
                          <div className={"ras-work-memo"}>
                            {item.memo}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
                
                <div>
                  <h4>
                    학력
                  </h4>
                  <div className={"ras-work"}>
                    {school.map((item)=>{
                      return(
                        <div>
                          <h4>
                            {item.title}
                          </h4>

                          <div className={"qu-add"}>
                            {item.major}
                          </div>

                          <div className={"qu-add"}>
                            {item.degree} 
                            {item.degree === "박사(통합) 과정" || item.degree === "박사(통합) 졸업" || item.degree === "석사 과정" || item.degree === "석사 졸업"
                            ? " / " + item.prof: null}
                          </div>

                          <div className={"qu-add"}>
                            {item.start}
                            {item.end !== "undefined/undefined" 
                            && " - " + item.end}
                          </div>

                          {/* EditorState? */}
                          <div className={"ras-work-memo"}>
                            {item.memo}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>

                <div>
                  <h4>
                    기타
                  </h4>
                  <div className={"ras-work"}>
                    <div>
                      <h4>논문</h4>
                      <ul>
                        {paper.map((item)=>{
                          return(
                            <li>
                              {/* <span>● </span> */}
                              {item.paperTitle}
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>

                  <div className={"ras-work"}>
                    <div>
                      <h4>수상</h4>
                      <ul>
                        {resume.awards && 
                        resume.awards.map((item)=>{
                          return(
                            <li>
                              {/* <span>● </span> */}
                              {item}
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>

                  <div className={"ras-work"}>
                    <div>
                      <h4>특허</h4>
                      <ul>
                        {resume.patents && 
                        resume.patents.map((item)=>{
                          return(
                            <li>
                              {/* <span>● </span> */}
                              {item}
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                  
                  <div className={"ras-work"}>
                    <div>
                      <h4>언어</h4>
                      <ul>
                        <li>
                          <div className={"ras-tag"}>
                            {resume.languages && 
                            resume.languages.map((item)=>{
                              return(<div>{item}</div>)
                            })}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>                      
                </div>

                <div>
                  <h4>
                    자기소개
                  </h4>
                  <div>
                    {resume.intro}
                  </div>
                </div>
                
              </ContentForm>
            </ProfileForm>


            <RightForm>

            </RightForm>
          </>
          :
            <>
              <ProfileForm>
                <HeaderForm>
                No data found
                </HeaderForm>
                <ContentForm>
                </ContentForm>
              </ProfileForm>
            </>
          }
          
        
        </RaWrapper>
      </Wrapper>   
      }
    </>
  )
}


const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  margin-top: 45px;
  display: block;
  position: relative;
`

const RaWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: flex;
  margin: 0 auto;
  background-color: whitesmoke;
`


const ProfileForm = styled.div`
  width: 70%;
  box-sizing: border-box;
  padding: 5px;
  padding-left: 0px;
  display: flex;
  margin: 0;
  flex-wrap: wrap;
  text-align: left;
  vertical-align: top;

  /* min-height: 300px; */

`

const HeaderForm = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    box-sizing: border-box;
    padding: 10px;

    min-height: 300px;

    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px 5px 0px 0px;
    border-bottom: none;

    >div{
      :last-child{
        /* margin-top: 60px; */
        display: flex;
        width: 100%;
        justify-content: flex-end;
        position: absolute;
        right: 20px;
        bottom: 20px;
        flex-direction: column;
        >div{
          display: flex;
          justify-content: flex-end;
          
          .choice-single{
            width: 150px;
            margin-left: 10px;
            font-size: .9rem;
            >div{
              width: 100%;
            }
          }
          /* :first-child{
            margin-bottom: 20px;
          } */
          >div{
            display: inline-flex;
            
            button{
              background-color: rgba(253,134,18, 0.8);
              padding: 7px;
              /* border: 1px solid rgba(150, 150, 150, 0.4); */
              border-radius: 10px;
              color: white !important;
              cursor: pointer;
              transition: .2s;
              width: 100px;
              border: none;
              margin-left: 20px;
              height: 35px;
              font-size: 1.00rem;
              font-weight: bold;
              
              :hover{
                background-color: rgba(253,134,18, 0.9);
              }
              :active{
                background-color: rgba(253,134,18, 1);
              }
              :last-child{
                color: rgba(253,134,18, 0.8) !important;
                background-color: transparent;
                border: .5px solid rgba(253,134,18, 0.8);
                cursor: not-allowed;
                :hover{
                  background-color: rgba(253,134,18, 0);
                }
                :active{
                  background-color: rgba(253,134,18, 0);
                }
              }

            }
          }

        }
      }
    }
`

const ContentForm = styled.div`
    width: 100%;
    position: relative;
    display: block;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    box-sizing: border-box;
    padding: 10px;
    padding-left: 30px;
    padding-right: 30px;

    background-color: rgba(255, 255, 255, 1);
    border-radius: 0px 0px 5px 5px;
    border-bottom: .5px solid rgba(0,0,0,0.2);

    >div{
      margin-bottom: 20px;
      font-size: 0.9rem;
      h4{
        margin: 0;
        padding-top: 20px;
        padding-bottom: 20px;
        font-weight: 600;
        opacity: .6;
      }
      >div{
        padding-left: 20px;
        font-size: 0.9rem;
      }
      .ras-tag{
        >div{
          display: inline-block;
          font-size: 0.8rem;
          border: .5px solid rgba(0,0,0,0.2);
          border-radius: 12px;
          padding: 7px;
          padding-left: 10px;
          padding-right: 10px;
          margin: 5px;
          margin-left: 0;
          margin-right: 10px;
        }
      }
      .ras-work{
        margin-bottom: 10px;
        h4{
          font-size: .9rem;
          padding-top: 0px;
          padding-bottom: 5px;
          opacity: 1;
        }
        .ras-work-memo{
          font-size: .9rem;
          /* margin-top: 10px; */
          margin-bottom: 10px;
        }
        /* span{
          display: inline-flex;
          justify-content: center;
          align-items: center;
        } */
        ul{
          padding-left: 20px;
        }
      }
    }
`




const ImgWrapper=styled.div`
  display: flex;
  height: 200px;
  width: 100%;

  justify-content: center;
  align-items: center;

  flex-direction: column;
  
  /* margin-bottom: 20px; */
  >img{
    width: 80px;
    height: 80px;
    border-radius: 50px;
    margin-bottom: 10px;
  }
  >div{
    margin-top: 3px;
    margin-bottom: 3px;
    font-size: 0.8rem;
    opacity: .6;
    
  }
  .name{
    font-size: .9rem;
    opacity: 1;
  }

`

const RightForm = styled.div`
  width: 30%;
  box-sizing: border-box;
  padding: 5px;
  padding-right: 0px;
  display: inline-block;
  margin: 0;
  
  text-align: left;
  vertical-align: top;
  
`

export default ComSingleSearch